import {
    BaseEdge,
    type EdgeProps,
    getStraightPath,
    EdgeLabelRenderer
} from 'reactflow';
import { useHoverStore } from '../../utils/store';

const CustomEdge = ({
    sourceX,
    sourceY,
    targetX,
    targetY,
    style = {},
    markerEnd,
    sourceHandleId,
    label,
    data,
}: EdgeProps) => {
    const [edgePath, labelX, labelY] = getStraightPath({
        sourceX,
        sourceY,
        targetX,
        targetY,
    });

    const hoveredPortId = useHoverStore((state) => state.hoveredPortId);
    const isHighlighted = hoveredPortId !== null && sourceHandleId === hoveredPortId;

    // Calculate rotation angle in degrees
    const angleInRad = Math.atan2(targetY - sourceY, targetX - sourceX);
    let angleInDeg = angleInRad * (180 / Math.PI);

    // Flip the text if it's upside down (more than 90 degrees)
    if (angleInDeg > 90 || angleInDeg < -90) {
        angleInDeg += 180;
    }

    return (
        <>
            <BaseEdge
                path={edgePath}
                style={{
                    ...style,
                    strokeWidth: isHighlighted ? 6 : 2,
                    stroke: '#3b82f6',
                    opacity: isHighlighted ? 0.3 : 0,
                }}
            />
            <BaseEdge
                path={edgePath}
                markerEnd={markerEnd}
                style={{
                    ...style,
                    strokeWidth: isHighlighted ? 5 : 3,
                    stroke: isHighlighted ? '#3b82f6' : (style.stroke || '#64748b'),
                    opacity: isHighlighted ? 1 : 0.4,
                    zIndex: isHighlighted ? 100 : 0,
                }}
            />

            {!data?.hideLabel && (label || data?.connection_type) && (
                <EdgeLabelRenderer>
                    <div
                        style={{
                            position: 'absolute',
                            // Combine translation and rotation
                            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px) rotate(${angleInDeg}deg)`,
                            fontSize: '8px',
                            fontWeight: 500,
                            color: isHighlighted ? '#3b82f6' : '#00bbf4ff',
                            pointerEvents: 'none',
                            whiteSpace: 'nowrap',
                            zIndex: 1000,
                            // Add a small translateY if you want it slightly above the line
                            marginBottom: '10px',
                        }}
                    >
                        {label || data?.connection_type}
                    </div>
                </EdgeLabelRenderer>
            )}
        </>
    );
};

export default CustomEdge;
